// Authoritative phone/email live in the patients table (patientRecord); the
// Withings program.getpatient demographics + roster prop are fallbacks only —
// getpatient carries no phone for ACCESS patients, so patientRecord wins.

interface PatientRecordLike { phone?: string | null; email?: string | null }
interface PatientDetailsLike {
  phone_number?: string | null;
  phone?: { number?: string | null } | null;
  email?: string | null;
}
interface PatientPropLike { phone_number?: string | null; email?: string | null }

export function resolvePatientPhone(
  patientRecord?: PatientRecordLike | null,
  patientDetails?: PatientDetailsLike | null,
  patient?: PatientPropLike | null,
): string | null {
  return (
    patientRecord?.phone
    || patientDetails?.phone_number
    || patientDetails?.phone?.number
    || patient?.phone_number
    || null
  );
}

export function resolvePatientEmail(
  patientRecord?: PatientRecordLike | null,
  patientDetails?: PatientDetailsLike | null,
  patient?: PatientPropLike | null,
): string | null {
  return patientRecord?.email || patientDetails?.email || patient?.email || null;
}
